module.exports = __webpack_public_path__ + "img/clock5.f70e6634.svg";